
import React, { Component, Fragment} from 'react';
import { ACTIVATE_LOC, SURVEYS_NO_LOC, MSG_ERR, MSG_OK, MSG_WARN , WITHIN_RAD} from '../App';
import LoadingSpinner from './LoadingSpinner';
import axios from 'axios';







export const QUESTION_TYPE_TEXT = 1;
export const QUESTION_TYPE_INT = 2;
export const QUESTION_TYPE_DECIMAL = 3;
export const QUESTION_TYPE_BOOLEAN = 4;
export const QUESTION_TYPE_MULTIPLE_SEL = 5;
export const QUESTION_TYPE_SINGLE_SEL = 6;
export const QUESTION_TYPE_RANK = 7;
export const QUESTION_TYPE_DATE = 8;
export const QUESTION_TYPE_TOP_OF_MIND = 9;
export const QUESTION_TYPE_IMAGE = 10;


const haversine = require('haversine')


const CLOUDINARY_CLOUD_NAME = "hgtpfagsv";
const CLOUDINARY_UPLOAD_PRESET = "UnsignedUpload";

const uploadImage = async (file) => {
    const url = `https://api.cloudinary.com/v1_1/${CLOUDINARY_CLOUD_NAME}/image/upload`;
    const data = new FormData();
    data.append("file", file);
    data.append("upload_preset", CLOUDINARY_UPLOAD_PRESET);

    const resp = await fetch(url, { method: "post", body: data });
    const fileData = await resp.json();

    if (!fileData.secure_url) {
        console.error("Cloudinary upload failed:", fileData);
        throw new Error(fileData.error?.message || "Image upload failed");
    }
    return fileData.secure_url;
};


class AnswerSurvey extends Component {

    state = {
        answers: {},
        pendingSvyResponse: null,
      }
    

    onChange = (qstnId, e) => {
      //   console.log("onChange" + e)  
        this.setState({
            answers: {
                ...this.state.answers,
                [qstnId]: { ...this.state.answers[qstnId], [e.target.name]: e.target.value }
            }
        })

    };



    onChange_single_select= (qstnId, e) => {
        //   console.log("onChange" + e)  
          this.setState({
              answers: {
                  ...this.state.answers,
                  [qstnId]: { ...this.state.answers[qstnId], ["answer_single_select"]: e.target.value }
              }
          })
  
      };
    
    onChangeImage = async (qstnId, e) => {
        if (e.target.files && e.target.files[0]) {
            const file = e.target.files[0];
            try {
                const secureUrl = await uploadImage(file);
                // URL stored per-question in answers — no shared image state
                this.setState({
                    answers: {
                        ...this.state.answers,
                        [qstnId]: {
                            ...this.state.answers[qstnId],
                            answer_image: secureUrl,
                        }
                    }
                });
            } catch (err) {
                const { displayMsg } = this.props;
                displayMsg("Error al subir la imagen. Intente de nuevo.", MSG_ERR);
            }
        }
    }

    onChangeBoolean = (qstnId, e) => {
        //   console.log("onChange" + e) 
        let bool = false
        if(e.target.id===(qstnId+"booleanTrue")) bool= true
          this.setState({
              answers: {
                  ...this.state.answers,
                  [ qstnId ]: { ...this.state.answers[qstnId], [e.target.name]: bool}
              }
          })

      };

    onChangeCheckBox = (qstnId, e) => {
        //   console.log("onChange" + e)  
          this.setState({
              answers: {
                  ... this.state.answers,
                  [qstnId]: { ... this.state.answers[qstnId], [e.target.name]: e.target.checked }
              }
          })

    };
    
    submitQuestionAnswers = async (svy_response) => {
        const { displayMsg } = this.props;

        const json_headers = {
            'Content-Type': 'application/json',
            'X-CSRFToken': localStorage.getItem('csrftoken'),
            Authorization: `Token ${localStorage.getItem('token')}`

                
        }
        
        if (!svy_response.id) return null;

        try {
            for (let ans in this.state.answers) {
                const answerData = this.state.answers[ans];
                const json_answer = {
                    from_survey_response: svy_response.id,
                    from_question_header: parseInt(ans, 10),
                    ...answerData,
                };
                await axios.post('/api/question_answer/', json_answer, { headers: json_headers });
            }
        } catch (err) {
            displayMsg("Error al guardar la respuesta. Intente de nuevo.", MSG_ERR);
            throw err;
        }
    };

    onSubmit = async (e) => {
        const { tasks_by_loc, selected_loc, active_survey, displayMsg, deleteSurveyFromTasksByLocifValid } = this.props

        e.preventDefault();

        const svy = tasks_by_loc[selected_loc].loc_surveys[active_survey];

        const json_survey_headers = {
            'Content-Type': 'application/json',
            'X-CSRFToken': localStorage.getItem('csrftoken'),
            Authorization: `Token ${localStorage.getItem('token')}`
        }

        // Reuse an existing survey_response if a previous attempt failed on answers
        let svyResponse = this.state.pendingSvyResponse;

        if (!svyResponse) {
            try {
                const res = await axios.post(
                    '/api/survey_response/',
                    {
                        "survey": svy.survey,
                        "response_loc": svy.svy_loc_scope_pk,
                        "response_col": localStorage.getItem('colId')
                    },
                    { headers: json_survey_headers }
                );
                svyResponse = res.data;
                this.setState({ pendingSvyResponse: svyResponse });
            } catch (err) {
                displayMsg("Error al registrar la respuesta. Intente de nuevo.", MSG_ERR);
                window.scrollTo(0, 0);
                return;
            }
        }

        try {
            await this.submitQuestionAnswers(svyResponse);
        } catch (err) {
            // Error already displayed by submitQuestionAnswers; stay on survey so user can fix and retry
            window.scrollTo(0, 0);
            return;
        }

        this.setState({ pendingSvyResponse: null });

        if (svyResponse?.id) {
            deleteSurveyFromTasksByLocifValid(
                svyResponse.id, selected_loc, active_survey,
                svy.loc_requiered ? ACTIVATE_LOC : SURVEYS_NO_LOC
            );
        }
    }
    


    
    componentDidMount() {
        const { getSvyQuestions, GetHeadingpoint } = this.props;
        GetHeadingpoint();
        getSvyQuestions();
    }

    componentWillUnmount() {}


    render_question(qstn) {

        const { tasks_by_loc, selected_loc, myLoc, active_survey } = this.props

        let qstnId = qstn.id

        let answer_single_select = null
        let answer_image = null


        let answer0_text = null
        let answer0_integer = null
        let answer0_boolean = null
        let answer0_decimal = null
    
        let answer1_text = null
        let answer1_integer = null
        let answer1_boolean = null
        let answer1_decimal = null
    
        let answer2_text = null
        let answer2_integer = null
        let answer2_boolean = null
        let answer2_decimal = null
    
        let answer3_text = null
        let answer3_integer = null
        let answer3_boolean = null
        let answer3_decimal = null
    
        let answer4_text = null
        let answer4_integer = null
        let answer4_boolean = null
        let answer4_decimal = null

        const start = {
            latitude: myLoc.lat,
            longitude: myLoc.lon
          }
          
        const end = {
                latitude: tasks_by_loc[selected_loc].loc_lat,
                longitude: tasks_by_loc[selected_loc].loc_lon
            }
        let loc_distance = Math.round(haversine(start, end, { unit: 'meter' }))

     /*   const selectOptions = [{ label: "--", value: 0 }, { label: "1", value: 1 }, { label: "2", value: 2 },
            { label: "3", value: 3 }, { label: "4", value: 4 }, { label: "5", value: 5 } ]
                              



        console.log("render_question")
        console.log(qstn) */
        
        const svy_scope = tasks_by_loc[selected_loc].loc_surveys[active_survey];
        const enforced = svy_scope.answer_at_location_enforced;
        const disabled = enforced && loc_distance > WITHIN_RAD;

        switch (qstn.question_type) {
            case QUESTION_TYPE_TEXT: {
                return (
                    <div>
                        <p className="text-muted small fst-italic mb-1">Tipo de pregunta: Texto</p>
                        <label className="form-label fw-semibold">{qstn.question}{qstn.question_mandatory && <span className="text-danger ms-1">*</span>}</label>
                        {qstn.question_image && <img className="image-gallery d-block mb-2" src={qstn.question_image} alt="" />}
                        <input
                            className="form-control"
                            type="text"
                            name="answer0_text"
                            onChange={(e) => this.onChange(qstnId, e)}
                            value={answer0_text}
                            disabled={disabled}
                            placeholder="Escriba su respuesta"
                        />
                    </div>)
            }
            case QUESTION_TYPE_INT: {
                return (
                    <div>
                        <p className="text-muted small fst-italic mb-1">Tipo de pregunta: Numero Entero</p>
                        <label className="form-label fw-semibold">{qstn.question}{qstn.question_mandatory && <span className="text-danger ms-1">*</span>}</label>
                        {qstn.question_image && <img className="image-gallery d-block mb-2" src={qstn.question_image} alt="" />}
                        <input
                            className="form-control"
                            type="number" pattern="[0-9]*"
                            name="answer0_integer"
                            onChange={(e) => this.onChange(qstnId, e)}
                            value={answer0_integer}
                            disabled={disabled}
                            placeholder="0"
                        />
                    </div>)
            }
            case QUESTION_TYPE_DECIMAL: {
                return (
                    <div>
                        <p className="text-muted small fst-italic mb-1">Tipo de pregunta: Decimal</p>
                        <label className="form-label fw-semibold">{qstn.question}{qstn.question_mandatory && <span className="text-danger ms-1">*</span>}</label>
                        {qstn.question_image && <img className="image-gallery d-block mb-2" src={qstn.question_image} alt="" />}
                        <input
                            className="form-control"
                            type="number" pattern="\d+((\.|,)\d+)?" step="0.01"
                            name="answer0_decimal"
                            onChange={(e) => this.onChange(qstnId, e)}
                            value={answer0_decimal}
                            disabled={disabled}
                            placeholder="0.00"
                        />
                    </div>)
            }
            case QUESTION_TYPE_BOOLEAN: {
                return (
                    <div>
                        <p className="text-muted small fst-italic mb-1">Tipo de pregunta: Verdaredo/Falso</p>
                        <label className="form-label fw-semibold">{qstn.question}{qstn.question_mandatory && <span className="text-danger ms-1">*</span>}</label>
                        {qstn.question_image && <img className="image-gallery d-block mb-2" src={qstn.question_image} alt="" />}
                        <div className="d-flex gap-3 mt-1">
                            <div className="form-check">
                                <input
                                    className="form-check-input"
                                    id={qstn.id + "booleanTrue"}
                                    type="radio"
                                    name="answer0_boolean"
                                    value={answer0_boolean}
                                    disabled={disabled}
                                    onChange={(e) => this.onChangeBoolean(qstnId, e)}
                                />
                                <label className="form-check-label" htmlFor={qstn.id + "booleanTrue"}>Sí</label>
                            </div>
                            <div className="form-check">
                                <input
                                    className="form-check-input"
                                    id={qstn.id + "booleanFalse"}
                                    type="radio"
                                    name="answer0_boolean"
                                    value={answer0_boolean}
                                    disabled={disabled}
                                    onChange={(e) => this.onChangeBoolean(qstnId, e)}
                                />
                                <label className="form-check-label" htmlFor={qstn.id + "booleanFalse"}>No</label>
                            </div>
                        </div>
                    </div>)
            }
            case QUESTION_TYPE_MULTIPLE_SEL: {
                const multiOptions = [
                    { name: "answer0_boolean", text: qstn.question_option_text0, img: qstn.question_option_image0, checked: answer0_boolean },
                    { name: "answer1_boolean", text: qstn.question_option_text1, img: qstn.question_option_image1, checked: answer1_boolean },
                    { name: "answer2_boolean", text: qstn.question_option_text2, img: qstn.question_option_image2, checked: answer2_boolean },
                    { name: "answer3_boolean", text: qstn.question_option_text3, img: qstn.question_option_image3, checked: answer3_boolean },
                    { name: "answer4_boolean", text: qstn.question_option_text4, img: qstn.question_option_image4, checked: answer4_boolean },
                ];
                return (
                    <div>
                        <p className="text-muted small fst-italic mb-1">Tipo de pregunta: Selección Multiple</p>
                        <label className="form-label fw-semibold">{qstn.question}{qstn.question_mandatory && <span className="text-danger ms-1">*</span>}</label>
                        {qstn.question_image && <img className="image-gallery d-block mb-2" src={qstn.question_image} alt="" />}
                        {multiOptions.map((opt, i) => (opt.text || opt.img) && (
                            <div className="form-check" key={i}>
                                <input
                                    className="form-check-input"
                                    id={qstn.id + opt.name}
                                    type="checkbox"
                                    name={opt.name}
                                    checked={opt.checked}
                                    disabled={disabled}
                                    onChange={(e) => this.onChangeCheckBox(qstnId, e)}
                                />
                                <label className="form-check-label" htmlFor={qstn.id + opt.name}>
                                    {opt.text}
                                </label>
                                {opt.img && <img className="image-option-gallery d-block mt-1" src={opt.img} alt="" />}
                            </div>
                        ))}
                    </div>
                )
            }
            case QUESTION_TYPE_SINGLE_SEL: {
                const singleOptions = [
                    { id: "answer_single_select1", text: qstn.question_option_text0, img: qstn.question_option_image0, value: qstn.question_option_text0 },
                    { id: "answer_single_select2", text: qstn.question_option_text1, img: qstn.question_option_image1, value: qstn.question_option_text1 },
                    { id: "answer_single_select3", text: qstn.question_option_text2, img: qstn.question_option_image2, value: qstn.question_option_text2 },
                    { id: "answer_single_select4", text: qstn.question_option_text3, img: qstn.question_option_image3, value: qstn.question_option_text3 },
                    { id: "answer_single_select5", text: qstn.question_option_text4, img: qstn.question_option_image4, value: qstn.question_option_text4 },
                ];
                return (
                    <div>
                        <p className="text-muted small fst-italic mb-1">Tipo de pregunta: Selección Unica</p>
                        <label className="form-label fw-semibold">{qstn.question}{qstn.question_mandatory && <span className="text-danger ms-1">*</span>}</label>
                        {qstn.question_image && <img className="image-gallery d-block mb-2" src={qstn.question_image} alt="" />}
                        {singleOptions.map((opt, i) => (opt.text || opt.img) && (
                            <div className="form-check" key={i}>
                                <input
                                    className="form-check-input"
                                    id={qstn.id + opt.id}
                                    type="radio"
                                    name={"answer_single_select" + qstn.id}
                                    value={opt.value}
                                    disabled={disabled}
                                    onChange={(e) => this.onChange_single_select(qstnId, e)}
                                />
                                <label className="form-check-label" htmlFor={qstn.id + opt.id}>
                                    {opt.text}
                                </label>
                                {opt.img && <img className="image-option-gallery d-block mt-1" src={opt.img} alt="" />}
                            </div>
                        ))}
                    </div>)
            }
            case QUESTION_TYPE_RANK: {
                const rankOptions = [
                    { name: "answer0_integer", text: qstn.question_option_text0, img: qstn.question_option_image0, value: answer0_integer },
                    { name: "answer1_integer", text: qstn.question_option_text1, img: qstn.question_option_image1, value: answer1_integer },
                    { name: "answer2_integer", text: qstn.question_option_text2, img: qstn.question_option_image2, value: answer2_integer },
                    { name: "answer3_integer", text: qstn.question_option_text3, img: qstn.question_option_image3, value: answer3_integer },
                    { name: "answer4_integer", text: qstn.question_option_text4, img: qstn.question_option_image4, value: answer4_integer },
                ];
                return (
                    <div>
                        <p className="text-muted small fst-italic mb-1">Tipo de pregunta: Ranqueo</p>
                        <label className="form-label fw-semibold">{qstn.question}{qstn.question_mandatory && <span className="text-danger ms-1">*</span>}</label>
                        {qstn.question_image && <img className="image-gallery d-block mb-2" src={qstn.question_image} alt="" />}
                        {rankOptions.map((opt, i) => (opt.text || opt.img) && (
                            <div className="d-flex align-items-center justify-content-between mb-2" key={i}>
                                <div>
                                    <span className="small">{opt.text}</span>
                                    {opt.img && <img className="image-option-gallery d-block mt-1" src={opt.img} alt="" />}
                                </div>
                                <select
                                    id={qstn.id + opt.name}
                                    className="form-select form-select-sm w-auto"
                                    name={opt.name}
                                    value={opt.value}
                                    disabled={disabled}
                                    onChange={(e) => this.onChange(qstnId, e)}
                                >
                                    <option>-</option>
                                    <option>1</option>
                                    <option>2</option>
                                    <option>3</option>
                                    <option>4</option>
                                    <option>5</option>
                                </select>
                            </div>
                        ))}
                    </div>)
            }
            case QUESTION_TYPE_DATE: {
                return (
                    <div>
                        <p className="text-muted small fst-italic mb-1">Tipo de pregunta: Fecha</p>
                        <label className="form-label fw-semibold">{qstn.question}{qstn.question_mandatory && <span className="text-danger ms-1">*</span>}</label>
                        <input
                            id={qstn.id + "answer0_text"}
                            className="form-control"
                            type="datetime-local"
                            name="answer0_text"
                            onChange={(e) => this.onChange(qstnId, e)}
                            value={answer0_text}
                            disabled={disabled}
                        />
                    </div>)
            }
            case QUESTION_TYPE_TOP_OF_MIND: {
                const tomOptions = [
                    { name: "answer0_text", label: qstn.question_option_text0, value: answer0_text },
                    { name: "answer1_text", label: qstn.question_option_text1, value: answer1_text },
                    { name: "answer2_text", label: qstn.question_option_text2, value: answer2_text },
                    { name: "answer3_text", label: qstn.question_option_text3, value: answer3_text },
                    { name: "answer4_text", label: qstn.question_option_text4, value: answer4_text },
                ];
                return (
                    <div>
                        <p className="text-muted small fst-italic mb-1">Tipo de pregunta: Textos Múltiples</p>
                        <label className="form-label fw-semibold">{qstn.question}{qstn.question_mandatory && <span className="text-danger ms-1">*</span>}</label>
                        {qstn.question_image && <img className="image-gallery d-block mb-2" src={qstn.question_image} alt="" />}
                        {tomOptions.map((opt, i) => (
                            <div className="input-group mb-2" key={i}>
                                {opt.label && (
                                    <span className="input-group-text small">{opt.label}</span>
                                )}
                                <input
                                    id={qstn.id + opt.name}
                                    className="form-control"
                                    type="text"
                                    name={opt.name}
                                    value={opt.value}
                                    disabled={disabled}
                                    onChange={(e) => this.onChange(qstnId, e)}
                                    placeholder={`${i + 1}°`}
                                />
                            </div>
                        ))}
                    </div>)
            }
            case QUESTION_TYPE_IMAGE: {
                return (
                    <div>
                        <p className="text-muted small fst-italic mb-1">Tipo de pregunta: Foto</p>
                        <label className="form-label fw-semibold">{qstn.question}{qstn.question_mandatory && <span className="text-danger ms-1">*</span>}</label>
                        {qstn.question_image && <img className="image-gallery d-block mb-2" src={qstn.question_image} alt="" />}
                        <input
                            className="form-control"
                            type="file"
                            name="answer_image"
                            value={answer_image}
                            disabled={disabled}
                            onChange={(e) => this.onChangeImage(qstnId, e)}
                        />
                        {this.state.answers[qstnId]?.answer_image && (
                            <img className="image-gallery mt-2" src={this.state.answers[qstnId].answer_image} alt="Preview" />
                        )}
                    </div>)
            }
            default: return null
        }
    }


    render() {
        const { svy_questions, tasks_by_loc, selected_loc, active_survey, myLoc, onCancel, getArrowPointingtoLoc} = this.props;

        if (!svy_questions?.length)
            return <LoadingSpinner />

        if (!tasks_by_loc[selected_loc].loc_surveys[active_survey])
            return <p>no question in survey</p>
    
        
            const start = {
                latitude: myLoc.lat,
                longitude: myLoc.lon
              }
              
            const end = {
                    latitude: tasks_by_loc[selected_loc].loc_lat,
                    longitude: tasks_by_loc[selected_loc].loc_lon
                }
            let loc_distance = Math.round(haversine(start, end, { unit: 'meter' }))
        
        
        
        
        const svy = tasks_by_loc[selected_loc].loc_surveys[active_survey];
        const loc = tasks_by_loc[selected_loc];
        const isInactive = !myLoc.lat || (svy.answer_at_location_enforced && loc_distance > WITHIN_RAD);

        return (
            <Fragment>
                {/* Survey header */}
                <div className="border-bottom pb-2 mb-3">
                    <h5 className="mb-1 fw-semibold">{svy.survey_title}</h5>
                    <div className="d-flex align-items-center small text-muted">
                        <span>{loc.loc_name} · {loc.loc_address} · {loc_distance} mts</span>
                        <img
                            className="ms-2"
                            width={22} height={22}
                            src={getArrowPointingtoLoc(end.latitude, end.longitude)}
                            alt="Dirección"
                        />
                    </div>
                    {isInactive && (
                        <div className="alert alert-warning py-1 px-2 mt-2 mb-0 small">
                            Debe entrar a la tienda para activar esta encuesta.
                        </div>
                    )}
                </div>

                {/* Questions */}
                <form onSubmit={this.onSubmit}>
                    {svy_questions.map((qstn) => (
                        <div className="card shadow-sm border-0 mb-3" key={qstn.id}>
                            <div className="card-body">
                                {this.render_question(qstn)}
                            </div>
                        </div>
                    ))}

                    {svy_questions.some(q => q.question_mandatory) &&
                        <p className="text-muted small mb-2"><span className="text-danger">*</span> Campo obligatorio</p>
                    }

                    {/* Submit / Cancel */}
                    <div className="d-flex gap-2 mt-2 mb-4">
                        <button
                            type="submit"
                            disabled={isInactive}
                            className="btn btn-primary flex-grow-1"
                        >
                            Enviar
                        </button>
                        <button
                            type="button"
                            onClick={() => onCancel(svy.loc_requiered ? ACTIVATE_LOC : SURVEYS_NO_LOC)}
                            className="btn btn-outline-secondary"
                        >
                            Cancelar
                        </button>
                    </div>
                </form>
            </Fragment>
        )
    }
}
 
export default AnswerSurvey;